export const useClipboard = ref => {
  const copyToClipboard = text => {
    if (text != null && text !== '' && typeof text !== 'object') {
      navigator.clipboard.writeText(String(text));
      return;
    }

    if (!ref?.current) return;

    ref.current.select();
    document.execCommand('copy');
  };

  return copyToClipboard;
};
